import PropTypes from 'prop-types';

import {Polygon} from 'fabric';

import {limitReached} from '../canvas-helper';

export const buildTrianglePolygon = (ax, ay, bx, by, cx, cy, stroke, width, fill) => {
    // Fabric Polygon stores points in absolute coords; setBoundingBox handles left/top
    return new Polygon(
        [{x: ax, y: ay}, {x: bx, y: by}, {x: cx, y: cy}],
        {
            strokeWidth: width,
            fill: fill ?? '',
            stroke: stroke,
            hasBorders: false,
            hasControls: false,
            objectCaching: false,
        }
    );
};

const Triangle = ({canvas, stroke, width, fill = ''}) => {

    let isDrawing = false;
    let poly = null;
    let startX = 0;
    let startY = 0;

    canvas.on('mouse:down', (o) => {
        if (limitReached(canvas)) return;
        if (canvas.getActiveObject()) return;

        isDrawing = true;
        const pointer = canvas.getScenePoint(o.e);
        startX = pointer.x;
        startY = pointer.y;
        poly = buildTrianglePolygon(startX, startY, startX, startY, startX, startY, stroke, width, fill);
        canvas.add(poly);
    });

    canvas.on('mouse:move', (o) => {
        if (!isDrawing) return;
        const pointer = canvas.getScenePoint(o.e);
        const ex = pointer.x;
        const ey = pointer.y;
        // apex = startX, startY; BL = startX, ey; BR = ex, ey
        const ax = startX, ay = startY;
        const bx = startX, by = ey;
        const cx = ex, cy = ey;
        canvas.remove(poly);
        poly = buildTrianglePolygon(ax, ay, bx, by, cx, cy, stroke, width, fill);
        canvas.add(poly);
        canvas.renderAll();
    });

    canvas.on('mouse:up', () => {
        isDrawing = false;
        if (poly) {
            const pts = poly.points;
            if (Math.abs(pts[1].x - pts[2].x) < 10 && Math.abs(pts[0].y - pts[1].y) < 10) {
                canvas.remove(poly);
                poly = null;
                canvas.renderAll();
                return;
            }

            // points are in absolute coords (Fabric Polygon convention)
            poly.custom = {
                type: 'triangle',
                ax: pts[0].x, ay: pts[0].y,
                bx: pts[1].x, by: pts[1].y,
                cx: pts[2].x, cy: pts[2].y,
            };
            canvas.remove(poly);
            canvas.add(poly);
            canvas.sendObjectToBack(poly);
        }
    });

};

Triangle.propTypes = {
    canvas: PropTypes.object.isRequired
};

export default Triangle;
